<template>
  <b-col
    md="6"
    lg="6"
  >
    <b-form-group>
      <label
        class="b-form-group-label"
      >
        {{ $t(label) }}
      </label>
      <label
        v-if="caseAllowedFilters.indexOf(labelFor) > -1"
      >
        <b-form-checkbox
          v-model="dateValues.is_dynamic"
          name="checkbox-input"
        ><span class="checkbox-text">({{ $t('DEBTIA_IF_DYNAMIC_DATE_TEXT') }})</span>
        </b-form-checkbox>
      </label>
      <b-input-group
        v-if="caseAllowedFilters.indexOf(labelFor) > -1"
      >
        <b-form-input
          v-if="dateValues.is_dynamic"
          id="Custom Fields"
          v-model="dateValues.no_of_days"
          type="text"
          :placeholder="$t('DEBTIA_NO_OF_DAYS')"
          trim
        />
        <b-input-group
          v-else
        >
          <b-input-group-prepend is-text>
            <b-form-checkbox
              v-model="dateValues.from_date.is_dynamic"
              name="checkbox-input"
            /> <label class="till-date-label">{{ $t('DEBTIA_DYNAMIC_FROM_DATE') }}?</label>
          </b-input-group-prepend>
          <flat-pickr
            v-if="!dateValues.from_date.is_dynamic"
            v-model="dateValues.from_date.value"
            class="form-control"
            :placeholder="$t('DEBTIA_FROM_DATE')"
          />
          <b-form-input
            v-else
            id="Custom Fields"
            v-model="dateValues.from_date.no_of_days"
            type="text"
            :placeholder="$t('DEBTIA_NO_OF_DAYS')"
            trim
          />
          <b-input-group-prepend is-text>
            <b-form-checkbox
              v-model="dateValues.till_date.is_dynamic"
              name="checkbox-input"
            /> <label class="till-date-label">{{ $t('DEBTIA_DYNAMIC_TILL_DATE') }}?</label>
          </b-input-group-prepend>
          <flat-pickr
            v-if="!dateValues.till_date.is_dynamic"
            v-model="dateValues.till_date.value"
            class="form-control"
            :placeholder="$t('DEBTIA_TILL_DATE')"
          />
          <b-form-input
            v-else
            id="Custom Fields"
            v-model="dateValues.till_date.no_of_days"
            type="text"
            :placeholder="$t('DEBTIA_NO_OF_DAYS')"
            trim
          />
        </b-input-group>
      </b-input-group>
      <b-form-input
        v-else
        disabled
      />
      <validation-provider
        #default="{ errors }"
        name="Current Process Enter Date"
        :rules="caseAllowedFilters.indexOf(labelFor) > -1 ? '' : ''"
      >
        <small class="text-danger">{{ errors[0] }}</small>
        <b-form-input
          v-model="dateValues.value"
          style="display: none;"
          disabled
        />
      </validation-provider>
    </b-form-group>
  </b-col>
</template>

<script>
import {
  BCol, BFormGroup, BFormInput, BInputGroup, BFormCheckbox, BInputGroupPrepend,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { ValidationProvider } from 'vee-validate'
import flatPickr from 'vue-flatpickr-component'
import { required } from '@validations'

export default {
  components: {
    BCol,
    BFormGroup,
    ValidationProvider,
    BFormInput,
    BInputGroup,
    flatPickr,
    BFormCheckbox,
    BInputGroupPrepend,
  },
  directives: {
    Ripple,
  },
  props: {
    caseAllowedFilters: {
      type: Array,
      required: true,
    },
    dateValues: {
      type: Object,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    labelFor: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      required,
    }
  },
  watch: {
    caseAllowedFilters: {
      handler() {
        // console.log('filters')
      },
    },
    'dateValues.is_dynamic': {
      handler() {
        if (this.dateValues.is_dynamic) {
          this.dateValues.from_date = {
            is_dynamic: false,
            no_of_days: null,
            value: null,
          }
          this.dateValues.till_date = {
            is_dynamic: false,
            no_of_days: null,
            value: null,
          }
        } else {
          this.dateValues.no_of_days = null
        }
      },
    },
    'dateValues.from_date.is_dynamic': {
      handler() {
        if (this.dateValues.from_date.is_dynamic) {
          this.dateValues.from_date.value = null
        } else {
          this.dateValues.from_date.no_of_days = null
        }
      },
    },
    'dateValues.till_date.is_dynamic': {
      handler() {
        if (this.dateValues.till_date.is_dynamic) {
          this.dateValues.till_date.value = null
        } else {
          this.dateValues.till_date.no_of_days = null
        }
      },
    },
  },
  created() {
  },
  methods: {
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-flatpicker.scss';

.margin-botton-3 label span {
  font-size: 10px !important;
}

.margin-botton-3 .custom-radio{
  margin-bottom: 6px;
  margin-top: 0px !important;
}

.b-form-group-label {
  margin-right: 10px;
}

.checkbox-text {
  font-size: 10px;
}

.till-date-label {
  margin-left: 5px;
}
</style>
